import React from 'react';
import PropTypes from 'prop-types';
import useInjectSagas from 'hooks/useInjectSagas';
import { SAGA_TYPES } from 'utils/constants';
import creditsRootSaga from 'sagas/credits';
import instancesRootSaga from 'sagas/instances';
import ordersRootSaga from 'sagas/orders';
import paymentMethodsRootSaga from 'sagas/paymentMethods';
import projectDataRootSaga from 'sagas/projectData';
import projectsRootSaga from 'sagas/projects';
import sessionsRootSaga from 'sagas/sessions';
import usersRootSaga from 'sagas/users';
import regionRootSaga from 'sagas/regions';

import ApiSetup from './ApiSetup';
import ProjectsSetup from './ProjectsSetup';
import LinkAccounts from './LinkAccounts';
import ActiveProjectSetup from './ActiveProjectSetup';
import RequireAuth from './RequireAuth';

const ServiceBootstrapper = ({ children }) => {
  useInjectSagas([
    { key: SAGA_TYPES.CREDITS, saga: creditsRootSaga },
    { key: SAGA_TYPES.INSTANCES, saga: instancesRootSaga },
    { key: SAGA_TYPES.ORDERS, saga: ordersRootSaga },
    { key: SAGA_TYPES.PAYMENT_METHODS, saga: paymentMethodsRootSaga },
    { key: SAGA_TYPES.PROJECT_DATA, saga: projectDataRootSaga },
    { key: SAGA_TYPES.PROJECTS, saga: projectsRootSaga },
    { key: SAGA_TYPES.SESSIONS, saga: sessionsRootSaga },
    { key: SAGA_TYPES.USERS, saga: usersRootSaga },
    { key: SAGA_TYPES.REGIONS, saga: regionRootSaga }
  ]);

  return (
    <RequireAuth>
      <ApiSetup>
        <LinkAccounts>
          <ProjectsSetup>
            <ActiveProjectSetup>{children}</ActiveProjectSetup>
          </ProjectsSetup>
        </LinkAccounts>
      </ApiSetup>
    </RequireAuth>
  );
};

ServiceBootstrapper.propTypes = {
  children: PropTypes.node.isRequired
};

export default ServiceBootstrapper;
